import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import LotEdit from '~/containers/lotEdit/lotEdit';

export class LotEditPage extends Component {
  state = {
    lot: null
  };

  onReceiveLocation = ({ lot }) => {
    this.setState({
      lot
    });
  };

  render() {
    const lotId = this.props.match.params.lotId;
    const { lot } = this.state;

    const editButton = (
      <div className="flex">
        <Link to={`/lots/${lotId}`}>
          <Button color="secondary">Cancel</Button>
        </Link>
      </div>
    );

    return (
      <Page>
        <TitleBar back={`/lots/${lotId}`} backText="Lot" title={lot ? lot.reference : '...'} button={editButton} />
        <LotEdit onCompleted={this.onReceiveLocation} id={lotId} />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(LotEditPage));



// WEBPACK FOOTER //
// ./src/pages/lotEdit/lotEdit.jsx